<template>
  <modal-container

    ref="modal"
    width="90%"
    maxWidth="420px"
    @close="$emit('update:activeModal', null)"
  >
    <div slot="modal-content"><sign-up-content @close="close()" @fillCart="fillCart" v-on="$listeners"/></div>
  </modal-container>
</template>

<script>

import SignUpContent from './SignUpContent'
export default {
  components: {
    SignUpContent
  },
  methods: {
    close() {
      this.$emit('update:activeModal', null)
      this.$refs.modal.close()
    },
    fillCart() {
      this.$emit('success')
    }
  }
}

</script>
